import { ProjectResourceItemsRevisionBase } from './base/project-resource-items-revision-base';

export class ProjectResourceItemsRevision extends ProjectResourceItemsRevisionBase { }